"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AutosuggestTextField_1 = require("./AutosuggestTextField");
exports.default = AutosuggestTextField_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/AutosuggestTextField/index.js
// module id = 1029
// module chunks = 8